import { Card, Col, Row, Form, Button, Dropdown } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import { RootState } from "redux/store";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import { getDepartments } from "redux/slices/Departments";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BulkEdit } from "./Popups/BulkEdit";
import { Stock } from "./Popups/Stock";
import { showToast } from "redux/slices/Toasts";
import { getSubDepartments } from "redux/slices/SubDepartment";
import { ParseAndValidateFloat, ToFixedNotRounded} from "helpers/data/dataHandling";
import { Modal, Spinner, Title, FormInput, ImportWizard, CustomColumns, CommonColumnProperties } from "components";
import { updatePriceGroupField, clearFilters, createPriceGroup, updatePriceGroup, cleanPriceGroups, getPriceGroupDetails, getPriceGroupsPrice, addSelectedRows, addDeselectedRows, applyPriceGroupsPrice, modifyPriceGroupsPrice, updatePriceGroupStock, addAGGridSelectedRows } from "redux/slices/PriceGroups";
import { runBatchWorkers } from "components/WebWorkers/ZWebWorker";
import { PriceGroupImportWorkerData, PriceGroupImportWorkerResponseData } from "./priceGroupImportWorker";
import { DataResponse } from "models/common/responseObjects";
import { AgGridReact } from "ag-grid-react";
import { getPriceGroupEditConfig } from "TableConfigs/PriceGroupEditConfig";
import BaseCellRenderer from "components/AgGrid/CellRenderers/BaseCellRenderer";
import PriceCellRenderer from "components/AgGrid/CellRenderers/PriceCellRenderer";
import PercentCellRenderer from "components/AgGrid/CellRenderers/PercentCellRenderer";
import { AgGridToolbar, AgGridToolbarRef } from "components/AgGrid/AgGridToolbar";
import { IServerSideDatasource } from "ag-grid-enterprise";
import { Z } from "models/common/components";
import { ZTooltip } from "components/ZTooltip";
import { ZIconType } from "helpers/utility/iconMap";
import { createBooleanSelectFilter, createSingleSelectFilter } from "components/AgGrid/FilterComponents/Filters";
import { ManagedSupplier } from "models/dbModels/managedSuppliers/ManagedSupplier";
import { ScheduleCodes } from "constants/constants";
import { ManagedDepartment } from "models/dbModels/managedDepartments/ManagedDepartment";
import { ManagedSubdepartment } from "models/dbModels/managedSubdepartments/ManagedSubdepartment";
import { ManagedStockGroup } from "models/dbModels/managedStockGroups/ManagedStockGroup";
import { ZButton } from "components/ZButton";
import EditablePriceCellRenderer from "components/AgGrid/CellRenderers/EditablePriceCellRenderer";
import MoneyCellEditor from "components/AgGrid/CellEditors/MoneyCellEditor";
import { ManagedManufacturer } from "models/dbModels/managedManufacturers/ManagedManufacturer";
import { getManufacturers } from "redux/slices/ManagedManufacturers";
import { getStockGroups } from "redux/slices/StockGroups";
import { getSuppliers } from "redux/slices/Suppliers";
import { LoadFilter, SaveFilter } from "helpers/filterStorage";

export function NewPriceGroup() {
    const form = useRef<any>(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { priceGroupId } = useParams();
    const priceGroupIdInt = parseInt(priceGroupId || "0");
    const [loading, setLoading] = useState<boolean>(false);
    const [originalName, setOriginalName] = useState<string>("");
    const [stockPopup, setStockPopup] = useState<boolean>(false);
    const [selectedStock, setSelectedStock] = useState<number>(0);
    const stocks = useAppSelector((state: RootState) => state.stocks);
    const [bulkEditPopup, setBulkEditPopup] = useState<boolean>(false);
    const [importPercentage, setImportPercentage] = useState<number>(0);
    const [isUpdatePriceGroup, setIsUpdatePriceGroup] = useState<boolean>(true);
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
    const [showImportWizard, setShowImportWizard] = useState<boolean>(false);
    const [loadingConfirmation, setLoadingConfirmation] = useState<boolean>(false);
    const priceGroup = useAppSelector((state: RootState) => state.priceGroups);
    const suppliers = useAppSelector((state: RootState) => state.suppliers);
    const user = useAppSelector((state: RootState) => state.logedinUser);
	const departments = useAppSelector((state: RootState) => state.department);
	const subDepartments = useAppSelector((state: RootState) => state.subDepartment);
	const stockGroups = useAppSelector((state: RootState) => state.stockGroups);
    const manufacturers = useAppSelector((state: RootState) => state.managedManufacturers);
    const [searchPdes, setSearchPdes] = useState<boolean | undefined>(undefined);
    const [searchApns, setSearchApns] = useState<boolean | undefined>(undefined);

    const [filterResetFlag, setFilterResetFlag] = useState<boolean>(false);

    const editPriceGroupGridRef = useRef<AgGridReact>(null);
    const toolbarRef = useRef<AgGridToolbarRef>(null);  

    useEffect(()=> {
        LoadFilter<{ searchPdes: boolean; searchBarcodes: boolean }>("StockSearchFilter").then((previousFilter) => {
            setSearchPdes(previousFilter?.searchPdes ?? false);
            setSearchApns(previousFilter?.searchBarcodes ?? false);
        });
        handleInitPriceGroup();
    },[]);

    useEffect(() => {
        if (filterResetFlag == true){
            editPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource());
            setFilterResetFlag(false);
        }
    }, [filterResetFlag])

    useEffect(() => {        
        if(editPriceGroupGridRef.current?.api != undefined)
        editPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource());
    }, [priceGroupIdInt, priceGroup.keyword]);

    useEffect(() => {
        if (priceGroup.departmentIdFilter !== 0) {
            dispatch(getSubDepartments(priceGroup.departmentIdFilter!));
        } else {
            handleUpdate("subdepartmentIdFilter", 0);
        }
    }, [priceGroup.departmentIdFilter]);

    function handleInitPriceGroup() {
        dispatch(getDepartments());
        dispatch(getManufacturers());
        dispatch(getStockGroups());
        dispatch(getSuppliers())
        dispatch(clearFilters());
        if (priceGroupIdInt) {
            setIsUpdatePriceGroup(true);
            dispatch(getPriceGroupDetails(priceGroupIdInt)).then((res) => {
                res.data[0].name && setOriginalName(res.data[0].name);
            });
            dispatch(getPriceGroupsPrice({ priceGroupIds: [priceGroupIdInt] }));
          
        } else {
            setIsUpdatePriceGroup(false);
            dispatch(cleanPriceGroups());
        }
    }

    function createNewPriceGroup() {
        dispatch(createPriceGroup({
            name: priceGroup.name,
            id: 0,
        })).then((res) => {
            navigate(`/app/price-group/${res.data[0]}`);
            handleUpdate("id", res.data[0]);
            setIsUpdatePriceGroup(true);
            setLoading(false);
        });
    }

    async function handleUpdatePriceGroup() {
        const res = await dispatch(updatePriceGroup({
            id: priceGroup.id,
            name: priceGroup.name,
        }));
        return res;
    }

    async function handleSave() {
        setLoading(true);
        // @ts-ignore

        if (!isUpdatePriceGroup) {
            createNewPriceGroup();
        } else {
            const res = await handleUpdatePriceGroup();
            handlePriceGroupUpdate(res);
        }
    }

    async function handleSubmit() {
        setLoading(true);       
        if (!isUpdatePriceGroup) {
            createNewPriceGroup();
        } else {
            setLoadingConfirmation(true);
            const res = await handleUpdatePriceGroup();
            await dispatch(applyPriceGroupsPrice({
                filter: {
                    priceGroupIds: [priceGroup.id],
                    ...(priceGroup.keyword !== "") && { managedStockKeyword: priceGroup.keyword },
                    managedStockIds: priceGroup.selectedRows.length > 0 ? priceGroup.selectedRows.map((item: any)  => item.id) : [],
                    ...priceGroup.departmentIdFilter !== null && { managedStockDepartmentIds: [priceGroup.departmentIdFilter] },
                    ...priceGroup.subdepartmentIdFilter !== null && { managedStockSubdepartmentIds: [priceGroup.subdepartmentIdFilter] },
                    offset: stocks.pageIndex * stocks.pageSize,
                    limit: stocks.pageSize,
                },
                sync: true,
                applyEmptyValues: false,
            }));
            await handlePriceGroupUpdate(res);
            editPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource());
        }        
    }

    async function handlePriceGroupUpdate(res: DataResponse<any>) {
        if (res.data) {
            dispatch(cleanPriceGroups());
            dispatch(getPriceGroupsPrice({ priceGroupIds: [priceGroupIdInt] }));
            dispatch(getPriceGroupDetails(priceGroupIdInt)).then((res) => {
                res.data[0].name && setOriginalName(res.data[0].name);
            });
            setShowConfirmation(false);
        } else {
            dispatch(showToast({ value: ["An unknown error occured"] }));
        }
        setLoading(false);
    }

    function onSearchClick(keyword: string | null) {
        if (searchApns !== undefined && searchPdes !== undefined) {
            SaveFilter("StockSearchFilter", { searchPdes: searchPdes, searchBarcodes: searchApns });
        }

        if(keyword == priceGroup.keyword){
            editPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource());
        }
        else {
            dispatch(updatePriceGroupField({ key: "keyword", value: keyword }));
        }	
        columnCheckDeselectAll();
    }

    function columnCheckDeselectAll() {
        editPriceGroupGridRef.current?.api.deselectAll();
		handleUpdate("deselectedRows", []);
		handleUpdate("selectedRows", []);
	}

    function onGridReady() {
        editPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource());
    }

    const getServerSideDatasource: () => IServerSideDatasource = () => {
        return {
                getRows: async (params) => {
                 const response = await dispatch(getPriceGroupsPrice({
                    managedStockKeyword: priceGroup.keyword,
                    ...getStockFilterOptions(),
                    priceGroupIds: [priceGroupIdInt],

                                      
                    offset: params.request.startRow,
                    limit: params.request.endRow != undefined && params.request.startRow != undefined ? params.request.endRow - params.request.startRow : 100,
                    SearchApns: searchApns,
                    SearchPdes: searchPdes,
                    sortModels: params.request.sortModel,
                }));

                if (response.data.length == 0) {
                    params.api.showNoRowsOverlay();
                    params.success({
                        rowData: [],
                        rowCount: 0
                    });
                    return;
                }

                params.api.hideOverlay();
                params.success({
                    rowData: response.data,
                    rowCount: response.totalRows,
                });
            }
        }
    }

    const CustomSearchButton = () => {
            return (
                <>
                    <Dropdown.Item onClick={() => setSearchPdes(!searchPdes)}>
                        <Form.Check
                            type="checkbox"
                            label="PDE"
                            checked={searchPdes}
                            onChange={() => setSearchPdes(!searchPdes)}
                            onClick={e => e.stopPropagation()}
                        />
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setSearchApns(!searchApns)}>
                        <Form.Check
                            type="checkbox"
                            label="APN"
                            checked={searchApns}
                            onChange={() => setSearchApns(!searchApns)}
                            onClick={e => e.stopPropagation()}
                        />
                    </Dropdown.Item>
                </>
            );
        }

    function resetFilter(){
        dispatch(updatePriceGroupField({ key: "supplierIdFilter", value: null }));
        dispatch(updatePriceGroupField({ key: "departmentIdFilter", value: null }));
        dispatch(updatePriceGroupField({ key: "subdepartmentIdFilter", value: null }));
        dispatch(updatePriceGroupField({ key: "manufacturerIdFilter", value: null }));
        dispatch(updatePriceGroupField({ key: "stockGroupIdFilter", value: null }));
        dispatch(updatePriceGroupField({ key: "scheduleFilter", value: null }));
        dispatch(updatePriceGroupField({ key: "pbsFilter", value: null }));
        dispatch(updatePriceGroupField({ key: "ethicalFilter", value: null }));
        dispatch(updatePriceGroupField({ key: "activeFilter", value: null }));
        setFilterResetFlag(true);
    }

    function getStockFilterOptions() {
        let payload: any = {};
        if (priceGroup.departmentIdFilter !== null) payload.managedStockDepartmentIds = [priceGroup.departmentIdFilter];
        if (priceGroup.subdepartmentIdFilter !== null) payload.managedStockSubdepartmentIds = [priceGroup.subdepartmentIdFilter];
        if (priceGroup.supplierIdFilter !== null) payload.managedStockSupplierIds = [priceGroup.supplierIdFilter];
        if (priceGroup.stockGroupIdFilter !== null) payload.managedStockStockGroupIds = [priceGroup.stockGroupIdFilter];
        if (priceGroup.manufacturerIdFilter !== null) payload.managedStockManufacturerIds = [priceGroup.manufacturerIdFilter];
        if (priceGroup.activeFilter !== null) payload.managedStockActive = priceGroup.activeFilter === true ? true : false;
        if (priceGroup.ethicalFilter !== null) payload.managedStockEthical = priceGroup.ethicalFilter === true ? true : false;
        if (priceGroup.scheduleFilter !== null) payload.managedStockSchedule = priceGroup.scheduleFilter;
        if (priceGroup.pbsFilter !== null) payload.managedStockPbs = priceGroup.pbsFilter === true ? true : false;
        return payload;
    }

    function handleUpdate(key: string, value: any) {
        dispatch(updatePriceGroupField({ key: key, value: value }));
    }

    function handleSubmitConfirmation() { 
        setLoading(false);
        setLoadingConfirmation(false);

        if (isUpdatePriceGroup) {
            setShowConfirmation(true);
        } else {
            handleSubmit();
        }
    }

    const importWizardExtraMatches: CustomColumns[] = [
        {
            title: "New Sell Price",
            key: "newSellPrice",
            required: true,
            display: true,
            autoMatch: ["sell", "sell price", "retail"],
            validation: (value: any) => {
                let res = ParseAndValidateFloat(value, 0)
                if (res.output) {
                    return { valid: true, error: "", newValue: ToFixedNotRounded(res.value, 2) }
                } else {
                    return { valid: false, error: "Sell price invalid" }
                }
            }
        },
    ];

    const terminateWorkersRef = useRef<Function>();

    async function BulkUpdateStock(rows: CommonColumnProperties[]) {
        const webWorkerData: PriceGroupImportWorkerData = {
			data: rows,
            priceGroupId: priceGroupIdInt,
		}

		const errors: Map<string, string> = new Map<string, string>();

		const { runWorkers, terminateWorkers } = runBatchWorkers<PriceGroupImportWorkerData, CommonColumnProperties, PriceGroupImportWorkerResponseData>({
            workerData: webWorkerData, 
            createWorker: () => new Worker(new URL('./priceGroupImportWorker.ts', import.meta.url)), 
            onWorkerResponse: (async (event, responseContext, httpErrors, reject) => {
                if (!responseContext.response.data) {
                    if (httpErrors) {
                        const combinedError = httpErrors.join(", ");
                        // Now using this combined error, construct a { stockName, error } object for each stock and push it onto the errors array
                        responseContext.originalBatchData.forEach((r: any) => {
                            const errorEntry = errors.get(r.name);
                            errors.set(r.name ?? "", errorEntry ? errorEntry + ", " + combinedError : combinedError);
                        });
                    }
                } else {
                    // Add to errors for each item in response.data.nonMatchingStocks in the structure { stockName: s, errorMsg: "Could not find a match for this stock" }
                    responseContext.response.data.nonMatchingStocks.forEach(nms => {
                        const errorEntry = errors.get(nms.name);
                        errors.set(nms.name ?? "", errorEntry ? errorEntry + ", " + "Could not match stock" : "Could not match stock");
                    })
                    
                    // Update the stocks
                    await dispatch(modifyPriceGroupsPrice(responseContext.response.data.updatedStocks));
                }

				setImportPercentage((prev) => Math.min(100, prev + ((1 / responseContext.numBatches) * 100)));
            }), 
            onWorkersFinished: async (_) => {
                dispatch(getPriceGroupsPrice({ priceGroupIds: [priceGroupIdInt] }));
                setImportPercentage(0); //Reset the import percentage
            }, 
            onWorkerError: (error, unprocessedData) => {
                unprocessedData.forEach(data => {
                    const errorEntry = errors.get(data.name ?? "");
                    const errorMessage = error.message ?? "Unknown error occurred";
                    errors.set(data.name ?? "", errorEntry ? errorEntry + ", " + errorMessage : errorMessage);
                })
            }
        });

        terminateWorkersRef.current = terminateWorkers;

        await runWorkers;

		const returnErrors: { stockName: string, error: string }[] = [];

		errors.forEach((value: string, key: string) => {
			returnErrors.push({
				stockName: key,
				error: value,
			})
		});

		return [...returnErrors];
    }

    function importWizardValidateForms(rows: CommonColumnProperties[]): CommonColumnProperties[] {
        let temp: CommonColumnProperties[] = [...rows];
        rows.forEach(row => {
            if (row.newSellPrice !== undefined) {
                const newSellPrice = row.newSellPrice;
                row.newSellPrice = parseFloat(newSellPrice);
            }
        });
        return temp;
    }

    return (
        <>
            <Title pageTitle={isUpdatePriceGroup ? "Update Price Group" : "New Price Group"} crumbs={[{ name: "Price Groups", path: "/app/price-groups" }]} />
            <Row>
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Form onSubmit={(e) => { 
                                e.preventDefault();
                                handleSubmitConfirmation();
                            }} ref={form}>
                                <Row>
                                    <h4 className="mt-2">Price Group Details</h4>
                                </Row>
                                <Row className="price-group-name">
                                    <Col xs={3}>
                                        <FormInput
                                            required
                                            label="Name"
                                            type="text"
                                            name="price-level-name"
                                            placeholder="Enter Name"
                                            containerClass={"mb-2"}
                                            value={priceGroup.name}
                                            onChange={(e) => handleUpdate("name", e.target.value)}
                                        />
                                    </Col>
                                    <Col xs={6} className="d-flex align-items-end">
                                        {priceGroup.name !== "" && originalName !== priceGroup.name && isUpdatePriceGroup &&
                                            <Button variant="primary" className="ms-1 extra-button btn cta-button" onClick={handleSave}>Save</Button>
                                        }
                                    </Col>
                                </Row>
                                {isUpdatePriceGroup && <>
                                    <div className="pb-1">
                                            <BulkEdit show={bulkEditPopup} handleClose={() => setBulkEditPopup(false)} />
                                            <Stock show={stockPopup} selectedStock={selectedStock} handleClose={() => setStockPopup(false)} />
                                            <Modal
                                                title="Confirm"
                                                show={showConfirmation}
                                                buttonType="primary"
                                                disableButtons={loadingConfirmation}
                                                buttonText={loadingConfirmation ? "Applying..." : "Continue"}
                                                handleSubmit={handleSubmit}
                                                handleClose={() => setShowConfirmation(false)}
                                                description={
                                                    <>
                                                        <p>You are about to apply {priceGroup.selectedRows.length > 0 ? priceGroup.selectedRows.length : priceGroup.totalRows} new sell price(s) and sync them to their assigned store(s).</p>
                                                        <p>Are you sure you want to continue?</p>
                                                    </>
                                                }
                                            />
                                            <ImportWizard
                                                title="Price Group Prices"
                                                display={showImportWizard}
                                                handleClose={() => { 
                                                    if (terminateWorkersRef.current) terminateWorkersRef.current();
                                                    setShowImportWizard(false); 
                                                }}
                                                importAsync={(i) => BulkUpdateStock(i)}
                                                customColumns={importWizardExtraMatches}
                                                validateTable={(rows) => importWizardValidateForms(rows)}
                                                matchAgainst="Stocks"
                                                finish={() => setShowImportWizard(false)}
                                                importPercentage={importPercentage}
                                            />

                                            <AgGridToolbar
                                                search={true}
                                                ref={toolbarRef}
                                                className="pb-1"
                                                handleSubmit={(searchState, filterState) => {
                                                    onSearchClick(searchState?.keyword != undefined? searchState.keyword: null);
                                                }}
                                                handleClearFilters={() => {
                                                    resetFilter();
                                                }}
                                                searchProps={
                                                    {
                                                        totalRows: priceGroup.totalRows, 
                                                        placeholder: "by Name" + (searchPdes === true ?" / PDE":"" ) + (searchApns === true? " / APN" : ""), customSearch: CustomSearchButton(),
                                                        hideContains: true
                                                    }
                                                }
                                                children={(
                                                    <div className="d-inline-flex gap-1">
                                                        {
                                                        (priceGroup.selectedRows != undefined && priceGroup.selectedRows.length != 0) &&									
                                                            <Z.Button variant="light" className="h-100" disabled={true} buttonText={priceGroup.selectedRows.length + " Selected"}/>
                                                        }
                                                        <ZTooltip text="Refresh">
                                                            <Z.Button icon={ZIconType.Refresh} buttonSize="md" onClick={() => editPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource())} disabled={!user.permissions.priceGroups.canView} />
                                                        </ZTooltip>
                                                        <ZTooltip text="Import From Spreadsheet">
                                                            <ZButton
                                                                style={{ height: 40 }}
                                                                size="sm"
                                                                className="btn-icon custom-btn-icon"
                                                                onClick={user.permissions.priceGroups.canImport ? () => setShowImportWizard(true) : undefined}
                                                                disabled={!user.permissions.priceGroups.canCreate || !user.permissions.priceGroups.canUpdate} 
                                                                icon={ZIconType.Upload}
                                                                iconSize="18px"/>
                                                        </ZTooltip>
                                                        {/**
                                                        <Dropdown>
                                                            <ZTooltip text="Export">
                                                                <Dropdown.Toggle variant="light" className="btn-icon custom-btn-icon" style={{ height: 40 }}>
                                                                    <ZIcon icon={ZIconType.Download} size="18px" />
                                                                </Dropdown.Toggle>
                                                            </ZTooltip>
                                                            <Dropdown.Menu className="w-auto">
                                                                <Dropdown.Item className="d-inline-flex align-items-center gap-1" 
                                                                    onClick={() => {
                                                                        editPriceGroupGridRef.current?.api.exportDataAsCsv(getEditPriceGroupkCsvDataFormatter()); }}>
                                                                        <ZIcon icon={ZIconType.File} /> CSV File</Dropdown.Item>
                                                                <Dropdown.Item className="d-inline-flex align-items-center gap-1" onClick={() => {
                                                                    let filters="";
                                                                    if(priceGroup.keyword != null)
                                                                        filters = "Search: "+ priceGroup.keyword+ ", \r\n";

                                                                    const spreadSheets = [];
                                                                    spreadSheets.push(editPriceGroupGridRef.current?.api.getSheetDataForExcel(getExportCoverPage(filters, "Edit Price Group")));
                                                                    spreadSheets.push(editPriceGroupGridRef.current!.api.getSheetDataForExcel(getEditPriceGroupDataFormatter()));
                                                                    editPriceGroupGridRef.current!.api.exportMultipleSheetsAsExcel({
                                                                        data: spreadSheets,
                                                                        fileName: "PriceGroupEdit" + new Date().toLocaleDateString('en-AU', {
                                                                            day : 'numeric',
                                                                            month : 'short',
                                                                            year : 'numeric',
                                                                            hour : '2-digit',
                                                                            minute : '2-digit'
                                                                        }).split(' ').join('-').replace(',', '') +".xlsx"
                                                                    });
                                                                }}><ZIcon icon={ZIconType.Excel} /> Excel File</Dropdown.Item>									
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                        **/}
                                                    </div>
                                                )}
                                                filters={[
                                                        createSingleSelectFilter<ManagedSupplier>({
                                                            label: "Supplier",
                                                            filterName: "supplierIds",
                                                            options: suppliers.table,
                                                            value: (option) => [option.id],
                                                            display: (option) => option.name,
                                                            hasNoneOption: true,
                                                            onFilterChange: function (e: ManagedSupplier | undefined): void {
                                                                if(e?.id != null)
                                                                    dispatch(updatePriceGroupField({ key: "supplierIdFilter", value: e?.id }));
                                                                else 
                                                                    dispatch(updatePriceGroupField({ key: "supplierIdFilter", value: null }));
                                                            },
                                                        }),
                                                        createSingleSelectFilter<ManagedDepartment>({
                                                            label: "Department",
                                                            filterName: "departmentIds",
                                                            options: departments.table,
                                                            value: (option) => [option.id],
                                                            display: (option) => option.name,
                                                            onFilterChange: function (e: ManagedDepartment | undefined): void {
                                                                if(e?.id != null)
                                                                    dispatch(updatePriceGroupField({ key: "departmentIdFilter", value: e?.id }));
                                                                else 
                                                                    dispatch(updatePriceGroupField({ key: "departmentIdFilter", value: null }));
                                                            },
                                                            hasNoneOption: true,
                                                        }),
                                                        createSingleSelectFilter<ManagedSubdepartment>({
                                                            label: "Sub Department",
                                                            filterName: "subdepartmentIds",
                                                            options: subDepartments.table.filter( i=> i.departmentId === priceGroup.departmentIdFilter),
                                                            value: (option) => [option.id],
                                                            display: (option) => option.name,
                                                            hasNoneOption: true,
                                                            onFilterChange: function (e: ManagedSubdepartment | undefined): void {
                                                                if(e?.id != null)
                                                                    dispatch(updatePriceGroupField({ key: "subdepartmentIdFilter", value: e?.id }));
                                                                else 
                                                                    dispatch(updatePriceGroupField({ key: "subdepartmentIdFilter", value: null }));
                                                            }
                                                        }),
                                                        createSingleSelectFilter<ManagedManufacturer>({
                                                            label: "Manufacturer",
                                                            filterName: "manufacturerIds",
                                                            options: manufacturers.table,
                                                            value: (option) => [option.id],
                                                            display: (option) => option.name,
                                                            hasNoneOption: true,
                                                             onFilterChange: function (e: ManagedManufacturer | undefined): void {
                                                                 if(e?.id != null)
                                                                    dispatch(updatePriceGroupField({ key: "manufacturerIdFilter", value: e?.id }));
                                                                else 
                                                                    dispatch(updatePriceGroupField({ key: "manufacturerIdFilter", value: null }));
                                                            }
                                                        }),
                                                        createSingleSelectFilter<ManagedStockGroup>({
                                                            label: "Stock Group",
                                                            filterName: "stockGroupIds",
                                                            options: stockGroups.table,
                                                            value: (option) => [option.id],
                                                            display: (option) => option.name,
                                                            hasNoneOption: true,
                                                            onFilterChange: function (e: ManagedStockGroup | undefined): void {
                                                                console.log(e);
                                                                if(e?.id != null)
                                                                    dispatch(updatePriceGroupField({ key: "stockGroupIdFilter", value: e?.id }));
                                                                 else 
                                                                    dispatch(updatePriceGroupField({ key: "stockGroupIdFilter", value: null }));
                                                            }
                                                        }),
                                                        createBooleanSelectFilter({
                                                            label: "Active",
                                                            filterName: "active",
                                                            hasNoneOption: true,
                                                            onFilterChange: function (e: boolean | undefined): void {
                                                                if(e != undefined)
                                                                    dispatch(updatePriceGroupField({ key: "activeFilter", value: e }));
                                                                else
                                                                    dispatch(updatePriceGroupField({ key: "activeFilter", value: null }));
                                                            }
                                                        }),
                                                        createBooleanSelectFilter({
                                                            label: "Ethical",
                                                            filterName: "ethical",
                                                            hasNoneOption: true,
                                                            onFilterChange: function (e: boolean | undefined): void {
                                                                 if(e != undefined)
                                                                    dispatch(updatePriceGroupField({ key: "ethicalFilter", value: e }));
                                                                else
                                                                 dispatch(updatePriceGroupField({ key: "ethicalFilter", value: null }));
                                                            }
                                                        }),
                                                        createSingleSelectFilter<string>({
                                                            label: "Schedule",
                                                            filterName: "schedule",
                                                            options: ScheduleCodes,
                                                            value: (option) => option,
                                                            display: (option) => option,
                                                            hasNoneOption: true,
                                                            onFilterChange: function (e: string | undefined): void {
                                                                 if(e != undefined)
                                                                    dispatch(updatePriceGroupField({ key: "scheduleFilter", value: e }));
                                                                else
                                                                 dispatch(updatePriceGroupField({ key: "scheduleFilter", value: null }));
                                                            }
                                                        }),
                                                        createBooleanSelectFilter({
                                                            label: "PBS",
                                                            filterName: "pbs",
                                                            hasNoneOption: true,
                                                            onFilterChange: function (e: boolean | undefined): void {
                                                                 if(e != undefined)
                                                                    dispatch(updatePriceGroupField({ key: "pbsFilter", value: e }));
                                                                else
                                                                    dispatch(updatePriceGroupField({ key: "pbsFilter", value: null }));
                                                            }
                                                        }),         
                                                    ]}
                                            />                                        
                                               
                                            <AgGridReact
                                                ref={editPriceGroupGridRef} 
                                                columnDefs={getPriceGroupEditConfig(true)}
                                                rowModelType="serverSide"
                                                pagination={true}
                                                paginationPageSize={20}
                                                containerStyle={{  height: "70dvh" }}
                                                className="ag-theme-quartz ag-theme-custom w-100"
                                                rowSelection="multiple"
                                                suppressRowClickSelection={true}
                                                singleClickEdit
                                                stopEditingWhenCellsLoseFocus={true}                                           
                                                onCellEditingStopped={(e)=> {
                                                    const parsedVal = parseFloat(e.newValue ?? "");
                                                    dispatch(modifyPriceGroupsPrice([{
                                                        ...e.data,
                                                        newPrice: parsedVal,
                                                    }])).catch()                                                  
                                                }}
                                                onGridReady={onGridReady}
                                                suppressContextMenu
                                                onRowSelected={() => {
                                                    let formatedData:{
                                                        positon: number,
                                                        id: number
                                                    } [] = []
                                                    var stocks = editPriceGroupGridRef.current?.api.getSelectedRows();                                              
                                                    stocks?.forEach((xe: any) => formatedData.push({ positon: 0, id: xe.managedStockId}));
                                                    dispatch(addAGGridSelectedRows(formatedData));
                                                }}
                                                components={{
                                                    baseCellRenderer: BaseCellRenderer,
                                                    editablePriceCellRenderer: EditablePriceCellRenderer,
                                                    priceCellRenderer: PriceCellRenderer,
                                                    percentCellRenderer: PercentCellRenderer,
                                                    moneyCellEditor: MoneyCellEditor
                                                }}
                                                
                                                excelStyles={[{
                                                    id: 'header',
                                                    font: {
                                                         bold: true
                                                    }
                                                },
                                                {
                                                    id:'numberAsString',
                                                    dataType: 'String'
                                                },
                                                {
                                                    id:'moneyField',
                                                    numberFormat: {
                                                        format: '$#,##0.00',
                                                    }
                                                }]}
                                            />                                            
                                    </div>
                                </>}
                                <Row className="mt-3 mb-2">
                                    <Col sm={6}>
                                        <Link to="/app/price-groups" className="btn text-muted d-none d-sm-inline-block btn-link fw-semibold" onClick={() => dispatch(cleanPriceGroups())}>
                                            <i className="mdi mdi-arrow-left"></i> Back to All Price Groups{" "}
                                        </Link>
                                    </Col>
                                    <Col sm={6} className="d-flex flex-row-reverse">
                                        {!isUpdatePriceGroup ?
                                            <Button variant="primary" className="ms-1 btn cta-button" onClick={handleSave} disabled={!user.permissions.priceGroups.canCreate}>
                                                {loading && <Spinner className="spinner-border-sm me-1" tag="span" color="white" />}
                                                {loading ? <>Saving...</> : <>Save</>}
                                            </Button>
                                            :
                                            <Button variant="primary" className="btn cta-button" disabled={loading || !user.permissions.priceGroups.canUpdate} onClick={handleSubmitConfirmation}>
                                                {loading && <Spinner className="spinner-border-sm me-1" tag="span" color="white" />}
                                                {loading ? <>Applying...</> : <>Apply & Sync</>}
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}